// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"ygPzE","vertical":"ISlfw","bullet":"_558Ks"};